interface ToggleProps {
  label: string;
  description: string;
  value: boolean;
  onChange: (value: boolean) => void;
  disabled?: boolean;
}

/** Interrupteur oui / non avec son libellé et une courte explication. */
export default function Toggle({ label, description, value, onChange, disabled }: ToggleProps) {
  return (
    <div className="flex items-center justify-between gap-4 rounded-md border border-background-200 bg-background-100/50 px-4 py-3">
      <div>
        <p className="text-sm font-medium text-foreground-900">{label}</p>
        <p className="text-sm text-foreground-500 mt-0.5">{description}</p>
      </div>
      <button
        type="button"
        role="switch"
        aria-checked={value}
        disabled={disabled}
        onClick={() => onChange(!value)}
        className={`relative h-6 w-11 shrink-0 rounded-full transition-colors duration-200 ease-out cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed ${value ? "bg-primary-600" : "bg-background-300"}`}
        aria-label={label}
      >
        <span className={`absolute left-0 top-0.5 h-5 w-5 rounded-full bg-white shadow-card transition-transform duration-200 ease-out ${value ? "translate-x-[1.375rem]" : "translate-x-0.5"}`}></span>
      </button>
    </div>
  );
}
